import React, { useState, useEffect, useRef } from 'react';

interface Props {
  onComplete: () => void;
}

const PROLOGUE_LINES = [
  '……。',
  '',
  '暗い。',
  '',
  '頭が重い。',
  '体が動かない。',
  '',
  '……ここは、どこだ？',
  '',
  '冷たい床の感触。',
  '埃の匂い。',
  '遠くで、何かが軋む音がする。',
  '',
  '薄目を開けると、',
  '月明かりに照らされた教室が見えた。',
  '',
  '机。椅子。黒板。',
  '見覚えがあるような、ないような。',
  '',
  'なぜ自分はここにいるのだろう。',
  '',
  '……思い出せない。',
  '',
  'ただ一つだけ、確かなことがある。',
  '',
  '',
  'ここから、出なければならない。',
];

export const Prologue: React.FC<Props> = ({ onComplete }) => {
  const [visibleLines, setVisibleLines] = useState(0);
  const [showSkip, setShowSkip] = useState(false);
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => setShowSkip(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [visibleLines]);

  useEffect(() => {
    if (visibleLines >= PROLOGUE_LINES.length) {
      const timer = setTimeout(onComplete, 3000);
      return () => clearTimeout(timer);
    }

    const line = PROLOGUE_LINES[visibleLines];
    const delay = line === '' ? 800 : 1200 + line.length * 40;

    const timer = setTimeout(() => {
      setVisibleLines(v => v + 1);
    }, delay);

    return () => clearTimeout(timer);
  }, [visibleLines, onComplete]);

  return (
    <div
      onClick={onComplete}
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0a0a0a',
        color: '#ccc',
        fontFamily: '"Noto Serif JP", "Yu Mincho", serif',
        padding: '2rem',
        boxSizing: 'border-box',
        cursor: 'pointer',
        overflow: 'hidden',
      }}
    >
      <div style={{
        maxWidth: '600px',
        width: '100%',
        maxHeight: '80vh',
        overflowY: 'auto',
        scrollBehavior: 'smooth',
        scrollbarWidth: 'none',
      }}>
        {PROLOGUE_LINES.slice(0, visibleLines).map((line, i) => (
          <p key={i} style={{
            fontSize: 'clamp(1.1rem, 3.5vw, 1.35rem)',
            lineHeight: '2',
            margin: '0.2rem 0',
            opacity: i === visibleLines - 1 ? 1 : 0.7,
            transition: 'opacity 1s',
            minHeight: '1.5em',
            letterSpacing: '0.1em',
          }}>
            {line}
          </p>
        ))}
        <div ref={bottomRef} />
      </div>

      {showSkip && (
        <p style={{
          position: 'absolute',
          bottom: '2rem',
          fontSize: '0.95rem',
          color: '#444',
          letterSpacing: '0.2em',
        }}>
          画面をクリックでスキップ
        </p>
      )}
    </div>
  );
};
